import {
  GETTER_IS_PASSWORD_LOADING_STATUS,
  GETTER_MESSAGE_ERROR,
} from './types';

export default {
  [GETTER_IS_PASSWORD_LOADING_STATUS]: ({ isLoading }) => isLoading,
  [GETTER_MESSAGE_ERROR]: ({ messageError }) => messageError,
};
